 document.addEventListener('DOMContentLoaded', function () {
    var accordionTitle = document.querySelector('.accordion-title');
    var accordionContent = document.querySelector('.accordion-content');

    accordionTitle.addEventListener('click', function () {
      var isOpen = accordionContent.style.display === 'block';
      accordionContent.style.display = isOpen ? 'none' : 'block';
      // Change arrow icon based on state
      accordionTitle.querySelector('.arrow-icon').innerHTML = isOpen ? '&#9654;' : '&#9660;'; // Unicode for down-pointing triangle
    });
  });